export enum BatchArchiveCatelogRuleType {
  SECTION = 'SECTION',
  MATERIAL = 'MATERIAL',
  STANDARD_TEST = 'STANDARD_TEST',
  WBS_DW_TYPE = 'WBS_DW_TYPE',
  WBS_DW = 'WBS_DW',
  WBS_FB = 'WBS_FB',
  WBS_SUB_FB = 'WBS_SUB_FB',
  WBS_FX = 'WBS_FX',
  WBS_SUB_FX = 'WBS_SUB_FX',
}

export enum BatchArchiveCatelogDisplayRuleType {
  CONSTRUCTION_SECTION = 'CONSTRUCTION_SECTION',
  SUPERVISE_SECTION = 'SUPERVISE_SECTION',
  SPOT_CHECK_SECTION = 'SPOT_CHECK_SECTION',
  JG_CHECK_SECTION = 'JG_CHECK_SECTION',
  COMPLETED_CHECK_SECTION = 'COMPLETED_CHECK_SECTION',
  MATERIAL_TYPE = 'MATERIAL_TYPE',
  STANDARD_TEST = 'STANDARD_TEST',
  WBS_DW_TYPE = 'WBS_DW_TYPE',
  WBS_DW = 'WBS_DW',
  WBS_FB = 'WBS_FB',
  WBS_SUB_FB = 'WBS_SUB_FB',
  WBS_FX = 'WBS_FX',
  WBS_SECTION = 'WBS_SECTION',
  WBS_STARTWITH_Q = 'WBS_STARTWITH_Q',
  WBS_STARTWITH_S = 'WBS_STARTWITH_S',
  WBS_STARTWITH_J = 'WBS_STARTWITH_J',
  WBS_STARTWITH_L = 'WBS_STARTWITH_L',
  WBS_STARTWITH_H = 'WBS_STARTWITH_H',
  WBS_STARTWITH_P = 'WBS_STARTWITH_P',
  WBS_STARTWITH_A = 'WBS_STARTWITH_A',
  WBS_STARTWITH_G = 'WBS_STARTWITH_G',
  WBS_STARTWITH_F = 'WBS_STARTWITH_F',
  WBS_STARTWITH_T = 'WBS_STARTWITH_T',
  WBS_STARTWITH_M = 'WBS_STARTWITH_M',
  WBS_STARTWITH_Z = 'WBS_STARTWITH_Z',
  WBS_STARTWITH_B = 'WBS_STARTWITH_B',
  WBS_STARTWITH_X = 'WBS_STARTWITH_X',
}

export const BatchArchiveCatelogDisplayRuleTypeMap = {
  [BatchArchiveCatelogDisplayRuleType.CONSTRUCTION_SECTION]: '基于施工标段',
  [BatchArchiveCatelogDisplayRuleType.SUPERVISE_SECTION]: '基于监理标段',
  [BatchArchiveCatelogDisplayRuleType.SPOT_CHECK_SECTION]:
    '基于试验标段（中心试验室）',
  [BatchArchiveCatelogDisplayRuleType.JG_CHECK_SECTION]: '基于交工标段',
  [BatchArchiveCatelogDisplayRuleType.COMPLETED_CHECK_SECTION]: '基于竣工标段',
  [BatchArchiveCatelogDisplayRuleType.STANDARD_TEST]: '基于标准试验',
  [BatchArchiveCatelogDisplayRuleType.MATERIAL_TYPE]: '基于材料类型',
  [BatchArchiveCatelogDisplayRuleType.WBS_DW_TYPE]: '基于WBS单位工程类型',
  [BatchArchiveCatelogDisplayRuleType.WBS_DW]: '基于WBS单位工程',
  [BatchArchiveCatelogDisplayRuleType.WBS_FB]: '基于WBS分部工程',
  [BatchArchiveCatelogDisplayRuleType.WBS_SUB_FB]: '基于WBS分部工程单元',
  [BatchArchiveCatelogDisplayRuleType.WBS_FX]: '基于WBS分项工程',
  [BatchArchiveCatelogDisplayRuleType.WBS_SECTION]: '基于WBS分项工程单元',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_Q]: '基于WBS桥梁工程（Q*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_S]: '基于WBS隧道工程（S*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_J]: '基于WBS路基工程（J*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_L]: '基于WBS路面工程（L*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_H]: '基于WBS绿化工程（H*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_P]:
    '基于WBS声屏障工程（P*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_A]:
    '基于WBS交通安全设施（A*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_G]:
    '基于WBS交通机电工程（G*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_F]: '基于WBS附属工程（F*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_T]:
    '基于WBS塔及辅助、过渡墩（T*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_M]: '基于WBS锚碇（M*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_Z]:
    '基于WBS上部钢结构制作与防护（Z*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_B]:
    '基于WBS上部结构浇筑与安装（B*）',
  [BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_X]:
    '基于WBS桥面系、附属工程及桥梁总体（X*）',
};

export const BatchArchiveCatelogDisplayRuleTypeList = [
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.CONSTRUCTION_SECTION
      ],
    value: BatchArchiveCatelogDisplayRuleType.CONSTRUCTION_SECTION,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.SUPERVISE_SECTION
      ],
    value: BatchArchiveCatelogDisplayRuleType.SUPERVISE_SECTION,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.SPOT_CHECK_SECTION
      ],
    value: BatchArchiveCatelogDisplayRuleType.SPOT_CHECK_SECTION,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.JG_CHECK_SECTION
      ],
    value: BatchArchiveCatelogDisplayRuleType.JG_CHECK_SECTION,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.COMPLETED_CHECK_SECTION
      ],
    value: BatchArchiveCatelogDisplayRuleType.COMPLETED_CHECK_SECTION,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.STANDARD_TEST
      ],
    value: BatchArchiveCatelogDisplayRuleType.STANDARD_TEST,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.MATERIAL_TYPE
      ],
    value: BatchArchiveCatelogDisplayRuleType.MATERIAL_TYPE,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_DW_TYPE
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_DW_TYPE,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_DW
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_DW,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_FB
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_FB,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_SUB_FB
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_SUB_FB,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_FX
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_FX,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_SECTION
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_SECTION,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_Q
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_Q,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_S
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_S,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_J
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_J,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_L
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_L,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_H
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_H,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_P
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_P,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_A
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_A,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_G
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_G,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_F
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_F,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_T
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_T,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_M
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_M,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_Z
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_Z,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_B
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_B,
  },
  {
    label:
      BatchArchiveCatelogDisplayRuleTypeMap[
        BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_X
      ],
    value: BatchArchiveCatelogDisplayRuleType.WBS_STARTWITH_X,
  },
];

export enum BatchWBSArchiveVolumnType {
  WBS_DW = 'WBS_DW',
  WBS_FB = 'WBS_FB',
  WBS_SUB_FB = 'WBS_SUB_FB',
  WBS_FX = 'WBS_FX',
  WBS_SECTION = 'WBS_SECTION',
  WBS_SEGMENT = 'WBS_SEGMENT',
  WBS_LAYER = 'WBS_LAYER',
}

export const BatchWBSArchiveVolumnTypeMap = {
  [BatchWBSArchiveVolumnType.WBS_DW]: '基于『单位工程』分卷',
  [BatchWBSArchiveVolumnType.WBS_FB]: '基于『分部工程』分卷',
  [BatchWBSArchiveVolumnType.WBS_SUB_FB]: '基于『分部工程单元』分卷',
  [BatchWBSArchiveVolumnType.WBS_FX]: '基于『分项工程』分卷',
  [BatchWBSArchiveVolumnType.WBS_SECTION]: '基于『分项工程单元』分卷',
  [BatchWBSArchiveVolumnType.WBS_SEGMENT]: '基于『分段』分卷',
  [BatchWBSArchiveVolumnType.WBS_LAYER]: '基于『分层』分卷',
};

export const BatchWBSArchiveVolumnTypeList = [
  {
    label: BatchWBSArchiveVolumnTypeMap[BatchWBSArchiveVolumnType.WBS_DW],
    value: BatchWBSArchiveVolumnType.WBS_DW,
  },
  {
    label: BatchWBSArchiveVolumnTypeMap[BatchWBSArchiveVolumnType.WBS_FB],
    value: BatchWBSArchiveVolumnType.WBS_FB,
  },
  {
    label: BatchWBSArchiveVolumnTypeMap[BatchWBSArchiveVolumnType.WBS_SUB_FB],
    value: BatchWBSArchiveVolumnType.WBS_SUB_FB,
  },
  {
    label: BatchWBSArchiveVolumnTypeMap[BatchWBSArchiveVolumnType.WBS_FX],
    value: BatchWBSArchiveVolumnType.WBS_FX,
  },
  {
    label: BatchWBSArchiveVolumnTypeMap[BatchWBSArchiveVolumnType.WBS_SECTION],
    value: BatchWBSArchiveVolumnType.WBS_SECTION,
  },
  {
    label: BatchWBSArchiveVolumnTypeMap[BatchWBSArchiveVolumnType.WBS_SEGMENT],
    value: BatchWBSArchiveVolumnType.WBS_SEGMENT,
  },
  // {
  //   label: BatchWBSArchiveVolumnTypeMap[BatchWBSArchiveVolumnType.WBS_LAYER],
  //   value: BatchWBSArchiveVolumnType.WBS_LAYER,
  // },
];

export enum BatchStandardTestArchiveVolumnType {
  TEST_TYPE = 'TEST_TYPE',
  TEST_YEAR = 'TEST_YEAR',
}

export const BatchStandardTestArchiveVolumnTypeMap = {
  [BatchStandardTestArchiveVolumnType.TEST_TYPE]: '基于『试验类型』分卷',
  [BatchStandardTestArchiveVolumnType.TEST_YEAR]: '基于『年份』分卷',
};

export const BatchStandardTestArchiveVolumnTypeList = [
  {
    label:
      BatchStandardTestArchiveVolumnTypeMap[
        BatchStandardTestArchiveVolumnType.TEST_TYPE
      ],
    value: BatchStandardTestArchiveVolumnType.TEST_TYPE,
  },
  {
    label:
      BatchStandardTestArchiveVolumnTypeMap[
        BatchStandardTestArchiveVolumnType.TEST_YEAR
      ],
    value: BatchStandardTestArchiveVolumnType.TEST_YEAR,
  },
];

export enum BatchMaterialArchiveVolumnType {
  MATERIAL_TYPE = 'MATERIAL_TYPE',
  MATERIAL_MODEL = 'MATERIAL_MODEL',
  MATERIAL_YEAR = 'MATERIAL_YEAR',
}

export const BatchMaterialArchiveVolumnTypeMap = {
  [BatchMaterialArchiveVolumnType.MATERIAL_TYPE]: '基于『材料类型』分卷',
  [BatchMaterialArchiveVolumnType.MATERIAL_MODEL]: '基于『规格型号』分卷',
  [BatchMaterialArchiveVolumnType.MATERIAL_YEAR]: '基于『年份』分卷',
};

export const BatchMaterialArchiveVolumnTypeList = [
  {
    label:
      BatchMaterialArchiveVolumnTypeMap[
        BatchMaterialArchiveVolumnType.MATERIAL_TYPE
      ],
    value: BatchMaterialArchiveVolumnType.MATERIAL_TYPE,
  },
  {
    label:
      BatchMaterialArchiveVolumnTypeMap[
        BatchMaterialArchiveVolumnType.MATERIAL_MODEL
      ],
    value: BatchMaterialArchiveVolumnType.MATERIAL_MODEL,
  },
  {
    label:
      BatchMaterialArchiveVolumnTypeMap[
        BatchMaterialArchiveVolumnType.MATERIAL_YEAR
      ],
    value: BatchMaterialArchiveVolumnType.MATERIAL_YEAR,
  },
];

export enum BatchRegularArchiveVolumnType {
  CONSTRUCTION_SECTION = 'CONSTRUCTION_SECTION',
  SUPERVISE_SECTION = 'SUPERVISE_SECTION',
  SPOT_CHECK_SECTION = 'SPOT_CHECK_SECTION',
  JG_CHECK_SECTION = 'JG_CHECK_SECTION',
  COMPLETED_CHECK_SECTION = 'COMPLETED_CHECK_SECTION',
  // MATERIAL_TYPE = 'MATERIAL_TYPE',
}

export const BatchRegularArchiveVolumnTypeMap = {
  [BatchRegularArchiveVolumnType.CONSTRUCTION_SECTION]: '基于『施工标段』分卷',
  [BatchRegularArchiveVolumnType.SUPERVISE_SECTION]: '基于『监理标段』分卷',
  [BatchRegularArchiveVolumnType.SPOT_CHECK_SECTION]:
    '基于『试验标段（中心试验室）』分卷',
  [BatchRegularArchiveVolumnType.JG_CHECK_SECTION]: '基于『交工标段』分卷',
  [BatchRegularArchiveVolumnType.COMPLETED_CHECK_SECTION]:
    '基于『竣工标段』分卷',
  // [BatchRegularArchiveVolumnType.MATERIAL_TYPE]: '基于『材料类型』分卷',
};

export const BatchRegularArchiveVolumnTypeList = [
  {
    label:
      BatchRegularArchiveVolumnTypeMap[
        BatchRegularArchiveVolumnType.CONSTRUCTION_SECTION
      ],
    value: BatchRegularArchiveVolumnType.CONSTRUCTION_SECTION,
  },
  {
    label:
      BatchRegularArchiveVolumnTypeMap[
        BatchRegularArchiveVolumnType.SUPERVISE_SECTION
      ],
    value: BatchRegularArchiveVolumnType.SUPERVISE_SECTION,
  },
  {
    label:
      BatchRegularArchiveVolumnTypeMap[
        BatchRegularArchiveVolumnType.SPOT_CHECK_SECTION
      ],
    value: BatchRegularArchiveVolumnType.SPOT_CHECK_SECTION,
  },
  {
    label:
      BatchRegularArchiveVolumnTypeMap[
        BatchRegularArchiveVolumnType.JG_CHECK_SECTION
      ],
    value: BatchRegularArchiveVolumnType.JG_CHECK_SECTION,
  },
  {
    label:
      BatchRegularArchiveVolumnTypeMap[
        BatchRegularArchiveVolumnType.COMPLETED_CHECK_SECTION
      ],
    value: BatchRegularArchiveVolumnType.COMPLETED_CHECK_SECTION,
  },
  // {
  //   label:
  //     BatchRegularArchiveVolumnTypeMap[
  //       BatchRegularArchiveVolumnType.MATERIAL_TYPE
  //     ],
  //   value: BatchRegularArchiveVolumnType.MATERIAL_TYPE,
  // },
];
